document.addEventListener('DOMContentLoaded', () => {

    if (document.body.getAttribute('data-accordion-description') === 'false') {
        return;
    }

    const container = document.querySelector('.ProductMeta__Description');
    if (!container) return;

    const shareButtons = container.querySelector('.ProductMeta__ShareButtons');

    const children = Array.from(container.children);
    const accordions = [];
    let current = null;

    children.forEach(node => {
        // Skip share buttons
        if (node.classList.contains('ProductMeta__ShareButtons')) return;

        const isTitle =
        node.tagName === 'P' &&
        node.querySelector('b, strong');

        if (isTitle) {
        current = { title: node.textContent.trim(), nodes: [] };
        accordions.push(current);
        return;
        }

        if (!current) return;

        // ❌ Remove empty Word-generated paragraphs
        const isEmptyMsoParagraph =
        node.tagName === 'P' &&
        node.classList.contains('MsoNormal') &&
        node.innerHTML.replace(/&nbsp;|\s/g, '') === '';

        if (isEmptyMsoParagraph) return;

        current.nodes.push(node.cloneNode(true));
    });

    if (!accordions.length) return;

    container.innerHTML = '';

    accordions.forEach(section => {
        const button = document.createElement('button');
        button.className = 'accordion';
        button.type = 'button';
        button.textContent = section.title;

        const safeTitle = section.title
        .toLowerCase()
        .replace(/[^a-z0-9]+/g, '-')
        .replace(/(^-|-$)/g, '');

        const panel = document.createElement('div');
        panel.className = `panel panel-${safeTitle}`;

        section.nodes.forEach(node => panel.appendChild(node));

        // Only append panel if it has real content
        if (panel.children.length) {
        container.appendChild(button);
        container.appendChild(panel);
        }
    });

    // Re-append share buttons unchanged
    if (shareButtons) {
        container.appendChild(shareButtons);
    }

    // Accordion toggle
    container.addEventListener('click', (e) => {
        if (!e.target.classList.contains('accordion')) return;

        e.target.classList.toggle('active');
        const panel = e.target.nextElementSibling;

        if (panel.style.maxHeight) {
        panel.style.maxHeight = null;
        } else {
        panel.style.maxHeight = panel.scrollHeight + 'px';
        }
    });
});
